export default __webpack_public_path__ + "static/media/Kan.29fc40f7.png";